<div class="flex items-center justify-between mb-4">
  <h2 class="text-lg font-semibold text-gray-800">Productos</h2>
  <span class="text-sm text-gray-500 bg-white px-3 py-1 rounded-full"
    >{{ productos_carrito().length }} agregados</span
  >
</div>

<!-- Botón para agregar productos -->
<div class="my-5 flex flex-col sm:flex-row gap-3 sm:gap-4">
  <button
    class="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2 group"
    (click)="modal_agregar_producto.set(true)"
  >
    <i class="bi bi-check-circle text-lg group-hover:scale-110 transition-transform"></i>
    <span>Agregar Productos</span>
  </button>
  @if (productos_carrito().length > 0) {
    <button
      class="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2 group"
      (click)="modal_confirmacion_eliminar_todos_productos.set(true)"
    >
      <i class="bi bi-x-circle text-lg group-hover:scale-110 transition-transform"></i>
      <span> Quitar Todos los Productos </span>
    </button>
  }
</div>

<!-- Área de productos agregados -->
<div class="flex-1 overflow-y-auto space-y-3 max-h-96">
  @for (item of productos_carrito(); track $index) {
    <div
      class="bg-white rounded-lg border border-gray-200 hover:shadow-md transition"
      [class.border-blue-300]="item.nota"
    >
      <!-- Encabezado del producto -->
      <div class="flex items-center justify-between p-3 pb-2">
        <div class="flex-1 min-w-0">
          <h3 class="font-semibold text-gray-800 truncate">{{ item.nombre }}</h3>
          <p class="text-xs text-gray-600">
            Cant: {{ item.cantidad }} | {{ item.precio | currency: 'PEN' : 'S/. ' }}
          </p>
        </div>
        <button
          type="button"
          class="ml-2 p-2 text-red-500 hover:bg-red-50 rounded-lg transition shrink-0"
          title="Eliminar producto"
          (click)="eliminarProducto($index)"
        >
          <i class="bi bi-trash"></i>
        </button>
      </div>

      <!-- Nota del producto (si existe) -->
      @if (item.nota && item.nota.trim() !== '') {
        <div class="px-3 pb-3 border-t border-gray-100">
          <div class="flex gap-2">
            <i class="bi bi-chat-dots text-yellow-500 shrink-0 text-sm mt-0.5"></i>
            <p class="text-xs text-gray-700 wrap-break-word leading-relaxed">
              {{ item.nota }}
            </p>
          </div>
        </div>
      }
    </div>
  } @empty {
    <div
      class="p-4 bg-white rounded-lg border border-dashed border-gray-300 text-center text-gray-500 text-sm"
    >
      <p>Los productos aparecerán aquí</p>
    </div>
  }
</div>

<!-- Resumen Total -->
@if (productos_carrito().length > 0) {
  <div class="mt-4 pt-4 border-t border-gray-300 bg-white rounded-lg p-3">
    <div class="flex justify-between font-semibold text-gray-800">
      <span>Total:</span>
      <span>{{ calcularTotal() | currency: 'PEN' : 'S/. ' }}</span>
    </div>
  </div>
}

<app-dialog
  header="Agregar Producto a la Venta"
  [(visible)]="modal_agregar_producto"
  [closable]="true"
  size="7xl"
  (onHide)="modal_agregar_producto.set(false)"
>
  @if (modal_agregar_producto() === true) {
    <app-agregar-producto-venta
      (agregar_productos)="onAgregarProducto($event)"
      (cerrar)="modal_agregar_producto.set(false)"
    />
  }
</app-dialog>

<app-dialog
  header="Confirmación"
  [(visible)]="modal_confirmacion_eliminar_todos_productos"
  [modal]="true"
  [closable]="true"
  size="xs"
  (onHide)="modal_confirmacion_eliminar_todos_productos.set(false)"
>
  <app-modal-confirmacion
    mensaje="¿Estás seguro de que deseas eliminar todos los productos agregados?"
    textoCancel="Cancelar"
    textoConfirm="Si, eliminar"
    (confirmar)="eliminarTodosProductos()"
    (cancelar)="modal_confirmacion_eliminar_todos_productos.set(false)"
  />
</app-dialog>
